// extracted by mini-css-extract-plugin
export default {"root_qr":"styles_root_qr__ggiuH","spin":"styles_spin__6dhwP"};